import { Injectable } from '@angular/core';
import { CenterLocation } from '../models/center-location';
import { GlobalDataStore } from '@core/lib/utils/httpRequestDataStorage/global-data.store';
import { DataType } from '@core/lib/utils/httpRequestDataStorage';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CenterLocationService extends GlobalDataStore<CenterLocation> {
  constructor() {
    super(
      {
        server: environment.api,
        endpoint: ['center', 'location'],
        retryTimes: 3,
      },
      DataType.ARRAY,
      {
        adapters: {
          incoming: CenterLocation.adapt,
          outgoing: CenterLocation.adaptAPI,
        },
        //database: { table: 'centerLocations', expiresIn: '1D' },
      }
    );
  }

  getAllCenterLocations() {
    this.fetchRecords([]);
  }

  createCenterLocation(data: CenterLocation) {
    this.createRecord(data);
  }

  updateCenterLocation(data: CenterLocation) {
    this.updateRecord(data);
  }

  deleteCenterLocation(data: CenterLocation) {
    this.deleteRecord(data);
  }
}
